import classNames from 'classnames';
import CountUp from 'react-countup';

const SeoServiceCard = props => {
  const { cardClass, suffix, headerClass, textClass, headerText, text } = props;
  return (
    <div className={classNames('flex justify-center items-center flex-col w-[255px] h-[132px] border-1 rounded-[18px] bg-white', cardClass)}>
      <p className={classNames('text-[48px] font-[600]', headerClass)}>
        <CountUp start={0} end={+headerText} suffix={suffix} duration={2.75}>
          {headerText}
        </CountUp>
      </p>
      <p className={textClass}>{text}</p>
    </div>
  );
};
export default SeoServiceCard;
